<template>
  <div class="balances">
    <div class="balances__multi__forms">
      <BalanceIssueManualForm />
      <BalanceIssueAutoForm />
    </div>

    <div class="balances__multi__requests">
      <div class="balances__multi__requests__header">
        <h2>Список процессов</h2>
        <div>
          <p
            :class="{ selected: selectedListStatus === 'pending' }"
            @click="() => selectListStatus('pending')"
          >
            Выполняется
          </p>
          <p
            :class="{ selected: selectedListStatus === 'completed' }"
            @click="() => selectListStatus('completed')"
          >
            Завершены
          </p>
        </div>
      </div>
      <div class="balances__multi__requests__table">
        <div class="balances__multi__requests__table__header">
          <p>ID админа</p>
          <p>Процесс</p>
          <p>Успешные</p>
          <p>Ошибочные</p>
          <p>Дата создания</p>
        </div>
        <div
          class="balances__multi__requests__table__row"
          v-for="process in processes"
          :key="process['_id']"
        >
          <p>{{ process['admin_id'] }}</p>
          <p>
            {{ process['error_requests_count'] + process['success_requests_count'] }}/{{
              process['total_requests_count']
            }}
          </p>
          <p>{{ process['success_requests_count'] }}</p>
          <p>{{ process['error_requests_count'] }}</p>
          <p>{{ parseDate(process['created_at']) }}</p>
        </div>
      </div>
      <div class="balances__multi__requests__pages">
        <button @click="prevPage" :disabled="currentPage === 1">←</button>

        <button
          v-for="page in paginationRange"
          :key="page"
          @click="goToPage(page)"
          :class="{ selected: page === currentPage }"
          :disabled="page === '...'"
        >
          {{ page }}
        </button>

        <button @click="nextPage" :disabled="currentPage === totalPages">→</button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import './balancesmulti.scss'

import { DatePicker, Calendar } from 'v-calendar'
import BalanceIssueManualForm from '../../components/BalanceMultiIssueForms/BalanceIssueManualForm.vue'
import BalanceIssueAutoForm from '../../components/BalanceMultiIssueForms/BalanceIssueAutoForm.vue'

export default {
  name: 'Balances',
  components: {
    BalanceIssueAutoForm,
    BalanceIssueManualForm,
    Calendar,
    DatePicker
  },
  data() {
    return {
      tabToggle: 'watch',
      autoUploadFileName: 'Выберите файл',
      autoUploadError: '',
      autoCreateError: '',
      autoTopt: '',
      autoBalanceIssueRequestToUpload: [],
      currency: {
        rub: 0,
        usd: 0,
        eur: 0
      },
      selectedListStatus: 'completed',
      totalPages: 0,
      currentPage: 1,
      processes: []
    }
  },
  watch: {
    selectedListStatus: {
      immediate: true,
      handler(value) {
        this.getProcesses(value, this.currentPage)
      }
    },
    currentPage: {
      handler(value) {
        this.getProcesses(this.selectedListStatus, value)
      }
    }
  },
  computed: {
    autoUploadStats() {
      const users = {}
      const amounts = {
        rub: 0,
        usd: 0,
        eur: 0
      }

      this.autoBalanceIssueRequestToUpload.forEach((item) => {
        users[item.user_id] = true
        amounts[item.currency] += item.sum
      })

      return `Вы хотите выдать баланс ${Object.keys(users).length} пользователям на сумму: ${
        amounts.rub
      }₽ | ${amounts.usd}$ | ${amounts.eur}€`
    },
    paginationRange() {
      const total = this.totalPages
      const current = this.currentPage
      const delta = 2
      const range = []
      let l

      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
          range.push(i)
        } else if (l && l !== '...') {
          range.push('...')
        }
        l = range[range.length - 1]
      }

      return range
    }
  },
  methods: {
    createBalanceIssueRequest() {
      const body = {
        code: this.topt,
        issues_requests: this.balanceIssueRequestToUpload
      }

      fetch(`https://auth.apineural.com/api/user/admin/balance/issues`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
        .then((res) => res.json())
        .then((data) => {
          if (!data.status) {
            const errorCodeToText = {
              invalid_topt: 'Неверный код 2фа',
              admin_balances_limits_exceeded: 'Вы превысили свои лимиты по выдаче баланса'
            }

            this.createError = errorCodeToText[data.error_code] || data.error_code
            return
          }

          this.resetAllFields()
        })
        .catch((err) => {
          console.log('error', err)
        })
    },
    onFileInput(event) {
      const file = event.target.files[0]
      if (!file) return

      this.uploadFileName = file.name

      const reader = new FileReader()
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        this.balanceIssueRequestToUpload = XLSX.utils.sheet_to_json(worksheet).map((item) => {
          return {
            user_id: item.user_id,
            sum: item.sum,
            currency: item.currency,
            comment: item.comment || ''
          }
        })
      }
      reader.readAsArrayBuffer(file)
    },
    resetAllFields() {
      this.createError = ''
      this.uploadError = ''
      this.uploadFileName = 'Выберите файл'
      this.balanceIssueRequestToUpload = []
      this.topt = ''

      this.$refs.excelFile.value = ''
    },
    selectListStatus(status) {
      this.selectedListStatus = status
    },
    getProcesses(status, page) {
      const perPage = 10

      fetch(
        `https://auth.apineural.com/api/user/admin/balance/issues?status=${status}&page=${page}&per_page=${perPage}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`
          }
        }
      )
        .then((res) => res.json())
        .then((data) => {
          this.currentPage = 1
          this.totalPages = data.data.pages
          this.processes = data.data.processes
        })
    },
    parseDate(rawDate) {
      const date = new Date(rawDate)

      const hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      const minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()

      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()} ${hours}:${minutes}`
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--
    },
    goToPage(page) {
      if (page !== '...') this.currentPage = page
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++
    }
  }
}
</script>
